export const CROUTON_TEST_IDS = {
    WRAPPER: "crouton-wrapper",
    TITLE: "crouton-title",
    CLOSE_BUTTON: "crouton-close-button",
};
